import React from 'react';
// nodejs library that concatenates classes

import GridContainer from 'components/MaterialKit/Grid/GridContainer.js';
import GridItem from 'components/MaterialKit/Grid/GridItem.js';
import Card from 'components/MaterialKit/Card/Card.js';
import CardHeader from 'components/MaterialKit/Card/CardHeader.js';
import CardBody from 'components/MaterialKit/Card/CardBody.js';
import CardFooter from 'components/MaterialKit/Card/CardFooter.js';
import Button from 'components/MaterialKit/CustomButtons/Button.js';
import Muted from 'components/MaterialKit/Typography/Muted.js';
import makeStyles from '@mui/styles/makeStyles';

import teamsStyle from 'assets/jss/nextjs-material-kit-pro/pages/sectionsSections/teamsStyle.js';
import teamStyle from 'assets/jss/nextjs-material-kit-pro/pages/landingPageSections/teamStyle.js';
import LinkIcon from '@mui/icons-material/Link';

import TEAMS from 'data/teams';
const style = {
    ...teamsStyle,
    ...teamStyle,
    justifyContentCenter: {
        justifyContent: 'center',
    },
};
const useStyles = makeStyles(style);

export default function SectionTeam() {
    const classes = useStyles();
    return (
        <div className={classes.team}>
            <a className={classes.anchor} id='the-team'  />
            <h2 className={classes.title}>The Team</h2>
            <h5 className={classes.description}>
        We are a team of geotechnical engineers integrating soils laboratory
        element testing, numerical modelling, and centrifuge testing with
        real-life monitoring data to provide meaningful monitoring solutions to
        the mining industry. We are based at the University of Western Australia
        in the School of Engineering. With the financial support and
        technological help from a range of monitoring technologies specialists,
        we bridge the knowledge gap between monitoring measurements and the
        meaningful interpretation of the data.
            </h5>
            <GridContainer>
                {TEAMS.map(member => (
                    <GridItem xs={12} sm={6} md={6} key={member}>
                        <Card profile plain className={classes.card3}>
                            <GridContainer>
                                <GridItem xs={12} sm={5} md={5}>
                                    <CardHeader image plain>
                                        <img src={member.imageSrc} alt="..." />
                                    </CardHeader>
                                </GridItem>
                                <GridItem xs={12} sm={7} md={7}>
                                    <CardBody plain>
                                        <h4 className={classes.cardTitle}>{member.name}</h4>
                                        <Muted>
                                            <h6 className={classes.cardCategory}>{member.position}</h6>
                                        </Muted>
                                    </CardBody>
                                    <CardFooter plain className={classes.justifyContentCenter}>
                                        {member.linkedInLink &&
                                      <Button justIcon simple color="linkedin" href={member.linkedInLink}>
                                          <i className="fab fa-linkedin-in" />
                                      </Button>}
                                        {member.researchLink &&
                                      <Button justIcon simple color="primary" href={member.researchLink}>
                                          <LinkIcon />
                                      </Button>}
                                    </CardFooter>
                                </GridItem>
                            </GridContainer>
                        </Card>
                    </GridItem>))}
            </GridContainer>
        </div>
    );
}
